import { render, staticRenderFns } from "./MessagePopUp.vue?vue&type=template&id=6b0e1914&"
import script from "./MessagePopUp.vue?vue&type=script&lang=js&"
export * from "./MessagePopUp.vue?vue&type=script&lang=js&"
import style0 from "./MessagePopUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports